import React from 'react';
import styles from './FooterModal.module.scss';
import RoundedButton from '../RoundedButton/RoundedButton';
import { Icon } from 'antd';

const FooterModal = ({
  onClose,
  onOk,
  isLoading = false,
  okText = 'Сохранить',
  disabled = false,
}) => {
  return (
    <div className={styles.root}>
      <RoundedButton
        text="Отмена"
        type="link"
        className={styles.cancel}
        onClick={onClose}
      />
      <RoundedButton
        text={okText}
        iconRight={
          <Icon
            style={{ color: 'white', fontSize: 16 }}
            type={isLoading ? 'loading' : 'check'}
          />
        }
        type="primary"
        className={styles.submit}
        disabled={disabled}
        onClick={onOk}
      />
    </div>
  );
};
export default FooterModal;
